import { ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/shared/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'

const STATUS_CONFIG = {
  open: {
    label: 'Open',
    className: 'border-blue-200 bg-blue-100 text-blue-700',
  },
  in_progress: {
    label: 'In Progress',
    className: 'border-amber-200 bg-amber-100 text-amber-700',
  },
  won: {
    label: 'Won',
    className: 'border-emerald-200 bg-emerald-100 text-emerald-700',
  },
  lost: {
    label: 'Lost',
    className: 'border-red-200 bg-red-100 text-red-700',
  },
}

const ALL_STATUSES = ['open', 'in_progress', 'won', 'lost']

export default function LeadStatusDropdown({ value = 'open', onChange }) {
  const [open, setOpen] = useState(false)
  const current = STATUS_CONFIG[value] || STATUS_CONFIG.open
  const options = ALL_STATUSES.filter((status) => status !== value)

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className={`h-7 min-w-[110px] rounded-full border px-2.5 text-[11px] font-medium shadow-none hover:bg-transparent ${current.className}`}
        >
          {current.label}
          {open ? (
            <ChevronUp className="ml-1 h-3 w-3" />
          ) : (
            <ChevronDown className="ml-1 h-3 w-3" />
          )}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start" className="w-44 rounded-2xl p-2">
        <DropdownMenuLabel className="px-2 pb-2 text-base font-semibold">
          Update status
        </DropdownMenuLabel>

        {options.map((status) => (
          <DropdownMenuItem
            key={status}
            onClick={() => onChange?.(status)}
            className="cursor-pointer rounded-xl px-3 py-2"
          >
            <span className="flex-1">
              {STATUS_CONFIG[status]?.label || status}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
